import React from "react";

import styles from "./Section6.module.scss";

export const Section6 = function () {
  return (
    <section id="conveners-section" className={`${styles.section6Wrapper} cc--component-container`}>
      <h3>YOUR FACULTY DIRECTORS</h3>
      <div className={styles.section6Container}>
        <div className={styles.section6Content}>
          <div className={styles.image} />
          <div className={styles.name}>
            <p>Thomas Malone</p>
            <p>
              <i>
                Patrick J. McGovern (1959) Professor of Management, MIT Sloan School of Management; Founding Director,
                MIT Center for Collective Intelligence
              </i>
            </p>
          </div>
          <div className={styles.summary}>
            <p>
              Malone is a professor of information technology and organizational studies at the MIT Sloan School of
              Management. His research focuses on how new organizations can be designed to take advantage of the
              possibilities provided by information technology.
            </p>
            <p>
              He has published his groundbreaking research in the book The Future of Work, and over 100 articles,
              research papers, and book chapters. His newest book, Superminds, appeared in May 2018. He holds 11
              patents, has co-founded three software companies, and is quoted in numerous publications such as Fortune,
              the New York Times, and Wired.
            </p>
            <p>
              Malone holds a BA from Rice University, two master&rsquo;s degrees, a PhD from Stanford University, and
              degrees in applied mathematics, engineering-economic systems, and psychology.
            </p>
          </div>
        </div>
        <div className={styles.section6Content}>
          <div className={styles.image2} />
          <div className={styles.name}>
            <p>Daniela Rus</p>
            <p>Director, MIT Computer Science and Artificial Intelligence Laboratory (CSAIL)</p>
          </div>
          <div className={styles.summary}>
            <p>
              Rus is the Andrew (1956) and Erna Viterbi Professor of Electrical Engineering and Computer Science and
              director of the Computer Science and Artificial Intelligence Laboratory (CSAIL) at MIT. She serves as the
              director of the Toyota-CSAIL Joint Research Center and is a member of the science advisory board of the
              Toyota Research Institute.
            </p>
            <p>
              Rus&rsquo; research interests are in robotics, mobile computing, and data science. Rus is a Class of 2002
              MacArthur Fellow, a fellow of ACM, AAAI and IEEE, and a member of the National Academy of Engineering and
              the American Academy of Arts and Sciences. She is the recipient of the 2017 Engelberger Robotics Award
              from the Robotics Industries Association. She earned her PhD in computer science from Cornell University.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
